/**
 * La clave con que `AnimatedRoutes` decide remontar la pantalla al cambiar de ruta. Es el `pathname`, salvo en la
 * pantalla del Pricer: `/pricer-datec/new` y `/pricer-datec/<id>` comparten clave, para que guardar una cotización
 * nueva (que cambia la ruta con `replace`) no remonte la pantalla ni pierda foco, scroll o lo que se está escribiendo.
 *
 * Las otras rutas de `/pricer-datec/` (la lista, la configuración, las del piloto `/editor/…`) NO se unen: son otras
 * pantallas y conservan su fundido de siempre.
 */
const SIN_CLAVE_PROPIA = new Set(['quotes', 'configuracion', 'approvals', 'editor']);

export function claveDeLaRuta(pathname: string): string {
  return pathname.replace(/(\/pricer-datec)\/([^/]+)$/, (todo, base: string, ultimo: string) =>
    SIN_CLAVE_PROPIA.has(ultimo) ? todo : `${base}/cotizacion`
  );
}
